import { redraw } from "./viewer";
import { BFF_BASE_PATH } from "@/core/utils"

export class Layer {
  constructor(level, width, height, image_width, image_height, real_level) {
    this.level = level;
    this.real_level = real_level;
    this.width = width;
    this.height = height;
    this.image_size = [image_width, image_height];
    this.columns = Math.ceil(width / image_width);
    this.rows = Math.ceil(height / image_height);
    this.image_size_in_percent = [image_width / width, image_height / height];
    this.zoom = 1;
    this.images = [];
    this.results = [];
    this.pixel_spacing = [0, 0];

    this.index = 0;
  }
}

export class ThumbnailImage {
  constructor() {
    this.image = new Image();
    this.valid = false;
    this.width = 0;
    this.height = 0;
    var img = this;

    this.image.onload = function () {
      if (img.image.width > 1 && img.image.height > 1) {
        img.valid = true;
        img.width = img.image.width;
        img.height = img.image.height;
        redraw();
      }
    };
  }
}

// class purpose is to split images requests between secondary servers
// main server is on port 5000, secondary servers are from port 5001 -
export class UrlHelper {
  constructor() {
    this.root = window.location.protocol + "//" + window.location.hostname;
    this.initial_port =
      parseInt(window.location.port, 10) || (window.location.protocol === "http:" ? 80 : 443);
    this.serverNums = 1;
    this.serversSet = new Set([self.initial_port]); // available servers
  }

  init(serverNums) {
    this.serversSet = new Set([this.initial_port]);
    var port;
    for (port = 1; port < serverNums; port++) this.serversSet.add(this.initial_port + port);
    this.serverNums = serverNums;
  }

  get_port(row, column, roi) {
    // select one out of available servers
    let ports = Array.from(this.serversSet);
    // best attempt for deterministic uniform distribution:
    // since a lot of images have one tile only (i.e. row and column equal 0 for many tiles),
    // adding roi values to the sum creates better distribution.
    // However there are some roi numbers that differ from each other only by first digits or
    // by last digits, thus we take 3 first digits and 3 last digits from each and add them all together
    var roi_index =
      Math.floor(
        Math.abs(roi.bottom) + Math.abs(roi.top) + Math.abs(roi.left) + Math.abs(roi.right) * 100
      ) +
      this.calc_descriminator(roi.bottom) +
      this.calc_descriminator(roi.top) +
      this.calc_descriminator(roi.left) +
      this.calc_descriminator(roi.right);

    // modifier is intended to add different meaning to the row vs. column numbers
    // for example, given one case where (column:0, row:1) and another where (column:1, row:0)
    // - we'd like to receive different results
    var modifier = ports.length == 7 ? 13 : 7;
    var index = (roi_index + row * modifier + column) % ports.length;

    //        console.log("PORT: " + ports[index] + " roi_index: " + roi_index + " col: " + column + " row: " + row +
    //                        " top: " + roi.top + " left: " + roi.left + " bottom: " + roi.bottom + " right: " + roi.right);
    return ports[index];
    //return ports[Math.floor((Math.random() * 100) % ports.length)];
  }

  // Make a number that consists of 3 last digits of a given number
  calc_descriminator(num) {
    var strVal = num.toString();
    if (strVal.indexOf(".") > -1) {
      strVal = strVal.split(".")[1];
    }
    if (strVal.length < 3) {
      return parseInt(num);
    }
    return parseInt(strVal.substr(strVal.length - 3, strVal.length));
  }

  get_url_pref(row, column, roi) {
    var port = this.get_port(row, column, roi);
    var pref = this.root + ":" + port;
    return pref;
  }

  invalidate_server_port(port) {
    // server at 'port' does not answer:
    //  remove it from available servers
    //  but not the main server, even if it is temporary off
    if (port != this.initial_port) this.serversSet.delete(port);
  }

  max_concurrent_requests() {
    // limit of concurrently loading slices strongly affects overall performance:
    // setting it to 1 * serverNums: server will be underloaded (~-30% to performance)
    // setting it to 3 * serverNums: ~-20% to performance
    //  1.5 * serverNums was measured as the optimum
    //  2 * serverNums is slightly worse

    // (╯°□°)╯︵ ┻━┻

    // var max_num = 1.5 * this.serverNums;
    // if (max_num < 2)
    //     return 2;
    // return Math.floor(max_num);

    return 6;
  }
}

export const urlHelper = new UrlHelper();

globals.userPreferences = {
  cb_invert_scroll_wheel: false,
};

export function savePreferences() {
  globals.userPreferences.cb_invert_scroll_wheel = $("#cb_invert_scroll_wheel")[0].checked;

  $.ajax({
    type: "PUT",
    url: `${BFF_BASE_PATH}/save_preferences`,
    data: JSON.stringify(globals.userPreferences),
    contentType: "application/json",
    error: function (jqXHR, textStatus, errorThrown) {
      handleServerError("save_preferences", jqXHR, textStatus);
      alert("Save preferences failed ");
      ping_server();
      return false;
    },
    success: function (_data) {
    },
  });
}

export function set_uv_coord(geometry, width, height) {
  var left = 0;
  var right = width;
  var top = 1;
  var bottom = 1 - height;
  geometry.faceVertexUvs[0][0][0].x = left;
  geometry.faceVertexUvs[0][0][0].y = top;
  geometry.faceVertexUvs[0][0][1].x = left;
  geometry.faceVertexUvs[0][0][1].y = bottom;
  geometry.faceVertexUvs[0][0][2].x = right;
  geometry.faceVertexUvs[0][0][2].y = top;
  geometry.faceVertexUvs[0][1][0].x = left;
  geometry.faceVertexUvs[0][1][0].y = bottom;
  geometry.faceVertexUvs[0][1][1].x = right;
  geometry.faceVertexUvs[0][1][1].y = bottom;
  geometry.faceVertexUvs[0][1][2].x = right;
  geometry.faceVertexUvs[0][1][2].y = top;
}

export function show_widget_inline_blocked(widget_name) {
  var x = document.getElementById(widget_name);
  x.style.display = "inline-block";
}

export function show_class_blocked(widget_name) {
  var x = document.getElementById(widget_name);
  x.style.display = "block";
}

export function hide_widget_inline_blocked(widget_name) {
  var x = document.getElementById(widget_name);
  x.style.display = "none";
}

export function show_class_inline_blocked(class_name) {
  var x = document.getElementsByClassName(class_name);
  x.style.display = "inline-block";
}

export function handleServerError(functionName, jqXHR, textStatus) {
  console.log("ERROR:" + functionName + " " + jqXHR.status + " " + textStatus);
  eventBridgeApi("error", {textStatus});
}

// use to filter input on a input text
(function ($) {
  $.fn.inputFilter = function (inputFilter) {
    return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      }
    });
  };
})(jQuery);

/*
    Keep
        zoom
        pan
        heatmaps
*/
export class PresentationState {
  constructor() {
    this.zoom = 1;
    this.start_pos = [0, 0];
    this.center_pos = [0, 0];
    this.size2actual = 1;
    this.zoom2fit = false;
  }
}

export function indexOfClosest(nums, target) {
  let closest = Number.MAX_SAFE_INTEGER;
  let index = 0;

  nums.forEach((num, i) => {
    let dist = Math.abs(target - num);

    if (dist < closest) {
      index = i;
      closest = dist;
    }
  });

  return index;
}

export function dispatchCustomEvent(eventName, target, detail) {
  const event = new CustomEvent(eventName, {
    bubbles: false,
    detail,
  });
  target.dispatchEvent(event);
}
export function eventBridgeApi(eventName, data) {
  const event = new CustomEvent("event-bridge-api", {
    bubbles: false,
    detail: { eventName, data },
  });
  document.getElementById('app').dispatchEvent(event);
}
